import * as React from 'react';

export const SelectAIFeedType = React.lazy(() => import('./SelectAIFeedType'));
